import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FullscreenBannerC = /*#__PURE__*/function (_React$Component) {
  _inherits(FullscreenBannerC, _React$Component);
  var _super = _createSuper(FullscreenBannerC);
  function FullscreenBannerC() {
    _classCallCheck(this, FullscreenBannerC);
    return _super.apply(this, arguments);
  }
  _createClass(FullscreenBannerC, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.documentElement.classList.add(styles['disabled-scroll']);
      document.body.classList.add(styles['disabled-scroll']);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.documentElement.classList.remove(styles['disabled-scroll']);
      document.body.classList.remove(styles['disabled-scroll']);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        url = _this$props.url,
        handleAccept = _this$props.handleAccept,
        handleDecline = _this$props.handleDecline;
      return /*#__PURE__*/_jsx("div", {
        className: styles['container'],
        children: /*#__PURE__*/_jsxs("div", {
          className: styles['content'],
          children: [/*#__PURE__*/_jsx("div", {
            className: styles['logo']
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("div", {
              className: styles['image-phone'],
              children: /*#__PURE__*/_jsx("div", {
                className: styles['image-message']
              })
            }), /*#__PURE__*/_jsx("div", {
              className: styles['image-shadow']
            }), /*#__PURE__*/_jsx("div", {
              className: styles['message'],
              children: /*#__PURE__*/_jsx("h4", {
                className: styles['title'],
                children: "\u0412 \u043D\u0430\u0448\u0435\u043C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u0438\u0441\u043A\u0430\u0442\u044C \u0435\u0449\u0451\xA0\u0443\u0434\u043E\u0431\u043D\u0435\u0435"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles['buttons'],
            children: [/*#__PURE__*/_jsx("a", {
              className: styles['link'],
              href: url,
              onClick: handleAccept,
              children: /*#__PURE__*/_jsx(Button, {
                fullWidth: true,
                theme: "fill_primary",
                size: "L",
                children: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C"
              })
            }), /*#__PURE__*/_jsx("span", {
              className: styles['link'],
              onClick: handleDecline,
              children: /*#__PURE__*/_jsx(Button, {
                fullWidth: true,
                theme: "fill_white_primary",
                size: "L",
                children: "\u041D\u0435\u0442, \u0441\u043F\u0430\u0441\u0438\u0431\u043E"
              })
            })]
          })]
        })
      });
    }
  }]);
  return FullscreenBannerC;
}(React.Component);